module.exports = __webpack_public_path__ + "img/cabins--full.381fe2d1.jpg";